import { AccessoryCheckMapper } from "./mappers/accessoryCheck";
import { AssetSubscriptionMapper } from "./mappers/assetSubscription";
import { BaseEntityMapper } from "./mappers/baseEntity";
import { CommonMapper } from "./mappers/common";
import { ContractMapper } from "./mappers/contract";
import { CustomerMapper } from "./mappers/customer";
import { DamageCostEvaluationMapper } from "./mappers/damageCostEvaluation";
import { DamageDetectionMapper } from "./mappers/damageDetection";
import { GeneralStatusHistoryMapper } from "./mappers/generalStatusHistory";
import { GenericDamageMapper } from "./mappers/genericDamage";
import { MaintenanceMapper } from "./mappers/maintenance";
import { RepairOperationMapper } from "./mappers/repairOperation";
import { RepairSpecMapper } from "./mappers/repairSpec";
import { ScheduleEntryMapper } from "./mappers/scheduleEntry";
import { VehicleMapper } from "./mappers/vehicle";
import { VehicleDamageMapper } from "./mappers/vehicleDamage";
import { VehicleVisualModelMapper } from "./mappers/vehicleVisualModel";
import { VisualInspectionMapper } from "./mappers/visualInspection";
import { WashMapper } from "./mappers/wash";
import { WheelOperationMapper } from "./mappers/wheelOperation";

export class Mapper {
  public static readonly common = CommonMapper;
  public static readonly baseEntity = BaseEntityMapper;
  public static readonly genericDamage = GenericDamageMapper;
  public static readonly visualModel = VehicleVisualModelMapper;
  public static readonly vehicle = VehicleMapper;
  public static readonly vehicleDamage = VehicleDamageMapper;
  public static readonly contract = ContractMapper;
  public static readonly customer = CustomerMapper;
  public static readonly accessoryCheck = AccessoryCheckMapper;
  public static readonly visualInspection = VisualInspectionMapper;
  public static readonly damageDetection = DamageDetectionMapper;
  public static readonly damageCostEvaluation = DamageCostEvaluationMapper;
  public static readonly repairOperation = RepairOperationMapper;
  public static readonly wash = WashMapper;
  public static readonly wheelOperation = WheelOperationMapper;
  public static readonly maintenance = MaintenanceMapper;
  public static readonly repairSpec = RepairSpecMapper;
  public static readonly generalStatusHistory = GeneralStatusHistoryMapper;
  public static readonly assetSubscription = AssetSubscriptionMapper;
  public static readonly scheduleEntry = ScheduleEntryMapper;
}
